import { MarketLayoutStylesSchema } from './MarketLayout.styles';

export const matchDetailsStyles: MarketLayoutStylesSchema = {
  headerText: {
    flex: '1',
    align: 'center',
    fontSize: '2xs',
    fontWeight: 'bold',
  },

  rowWrapper: {
    px: '4',
    py: '2',
    alignItems: 'center',
    display: 'flex',
    fontSize: 'xs',
    fontWeight: 'bold',
    justifyContent: 'space-between',
    borderColor: 'transparent',
    borderTopWidth: undefined,
    gap: '2',
    pos: 'relative',
    color: 'gray.700',

    _before: {
      borderColor: 'blackAlpha.400',
      borderBottomWidth: '1px',
      boxShadow: '0 1px rgba(255, 255, 255, .07)',
      content: '""',
      w: 'full',
      left: '0',
      pos: 'absolute',
      top: '-1px',
    },
  },
  rowWrapperFirst: {
    borderTopWidth: '1px',

    _before: {
      display: 'none',
    },
  },
  rowWrapperWithBtn: {
    bg: 'epsilon.300',
  },

  tab: {
    bg: 'alpha.500',
    borderBottom: '1px',
    borderColor: 'white',
    borderBottomColor: 'alpha.500',
    color: 'alpha.800',
    fontSize: '2xs',
    fontWeight: 'bold',
    _notFirst: { borderLeftWidth: '1px' },
    _selected: {
      bg: 'alpha.700',
      borderBottomColor: 'transparent',
      color: 'white',
    },
  },
};
